// Nov 2026: beberapa notifikasi nakes menyimpan tautan ke halaman yang tidak ada.
// Fungsi ini mengubahnya ke halaman nakes yang benar. Mengembalikan null bila tidak ada tujuan yang jelas.

export function resolveNakesNotificationLink(n) {
  if (!n) return null;
  let url = n.action_url || n.link_url || n.link || n.deep_link || null;
  if (url && typeof url === 'string') {
    const clean = url.split('?')[0].replace(/\/+$/, '');
    if (/^\/nakes\/warning-letters\/[^/]+$/.test(clean)) return '/nakes/warning-letters';
    if (clean === '/nakes/leave') return '/nakes/attendance';
    if (/^\/nakes\/payslip(\/.*)?$/.test(clean)) return '/nakes/rekap-gaji';
    if (clean === '/nakes/job-pool') return '/nakes/jobs/shared';
    if (clean === '/nakes/documents') return '/nakes/profile';
    const ret = clean.match(/^\/nakes\/returns\/([^/]+)$/);
    if (ret) return `/nakes/logistic-returns/${ret[1]}`;
    return url;
  }
  if (n.order_id) return `/nakes/jobs/${n.order_id}/workflow`;
  return null;
}
